export enum RoomServiceEndpoints {
    PostRoomInfo = '/v1/room/info',
    GetRoomAvailability = '/v1/room/availability',
}
